// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".reward-quantity-display[data-v-19b59cd6] {\n  color: #28c76f;\n  font-size: 0.95rem;\n  min-width: 60px;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}[dir] .reward-quantity-display[data-v-19b59cd6] {\n  background-color: rgba(40, 199, 111, 0.12);\n}", ""]);
// Exports
module.exports = exports;
